module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/cover-sp-1abc9fbac87521d223f1f969582db4a4.webp";